// Domains the Master Admin dropdowns offer (MAP-4360): only the ones with real data,
// i.e. with subscriptions and locations, from the billing domains summary.
export interface DomainSummaryRow {
  domain: string;
  essential: number;
  basic: number;
  ultimate: number;
  subscriptions: number;
}

export function domainsWithData(rows: DomainSummaryRow[]): string[] {
  const names = (rows || [])
    .filter(row => row.domain && row.subscriptions > 0 && (row.essential + row.basic + row.ultimate) > 0)
    .map(row => row.domain);
  return [...new Set(names)].sort();
}
